import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DocumentosService } from 'src/app/servicios/documentos.service';
import { ServiceService } from 'src/app/servicios/service.service';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { Loading } from 'src/app/Class/Loading';

@Component({
  selector: 'app-nueva-version-documento',
  templateUrl: './nueva-version-documento.component.html',
  styleUrls: ['./nueva-version-documento.component.css']
})
export class NuevaVersionDocumentoComponent implements OnInit {

  public formdocumento: FormGroup;
  public categoria: any = [];
  public subcategoria: any = [];
  public tipo_documento: any = [];
  public facultades: any = [];
  public programas: any = [];
  public unidades: any = [];
  public normas: any = [];
  public estamentos: any = [];
  public palabras_clave: any = [];
  public id: any;
  public url: string = null;

  constructor( private documentoService: DocumentosService,
               private form: FormBuilder,
               private serviceService: ServiceService,
               private rout: ActivatedRoute,
               private router: Router,
               public loading: Loading ) {

                this.loading.estado = true;

                this.url = this.serviceService.server ;

                this.documentoService.GetInfoCrear().subscribe(datos => {
                  this.categoria = datos['categoria'];
                  this.subcategoria = datos['subcategoria'];
                  this.tipo_documento = datos['tipo_documento'];
                  this.facultades = datos['facultades'];
                  this.programas = datos['programas'];
                  this.unidades = datos['unidades'];
                  this.estamentos = datos['estamentos'];
                  this.normas = datos['normas'];
                  this.palabras_clave = datos['palabras_clave'];
                  this.loading.estado = false;
                },
                err => {  this.loading.estado = false; }
                );

                this.formdocumento = this.form.group({
                  id: [null],
                  categoria_id: [ , Validators.required],
                  subcategoria_id: [ , Validators.required],
                  tipodocumento_id: [ , Validators.required],
                  titulo: ['' , Validators.required ],
                  descripcion: ['' , Validators.required],
                  archivo: ['', Validators.required],
                  fecha_expedicion: ['', ],
                  fecha_publicacion: ['', ],
                  facultad_id: [],
                  programa_id: [],
                  unidad_id: [],
                  norma_id: [],
                  estamentos_id: [],
                  palabras_clave_selected: [],
                  codigo: [, Validators.required],
                  numero_version: [, Validators.required],
                  publicado: [false]
                });

                this.rout.params.subscribe(parametros => { this.id = parametros['id']; });
                if (this.id !== 'null' ) {
                        this.documentoService.getDocumento(this.id).subscribe(data => {
// tslint:disable-next-line: forin
                          for ( const atributos  in this.formdocumento.value) {
                            this.formdocumento.get(atributos).setValue(data['documento'][atributos]);
                          }
                        });
                }
              }

  ngOnInit() {
  }

  onFileSelect(event) {
    if (event.target.files.length > 0) {
    const file = event.target.files[0];
    this.formdocumento.get('archivo').setValue(file);
    }
  }
  addTagPalabra(nombre) {
    return { nombre: nombre, tag: true };
  }

  guardarNuevaVersion() {
    this.loading.estado = true;
    this.documentoService.GuardarNuevaVersion(this.formdocumento.value)
      .subscribe(data => {
        if (data['success']) {
            Swal.fire({ type: 'success', title: 'Guardado exitoso', showConfirmButton: false, timer: 1500 });
            this.router.navigate(['/documentos/listado']);
          } else {
            Swal.fire({ type: 'warning', title: 'No se pudo completar la solicitud', showConfirmButton: false, timer: 1500 });
          }
        this.loading.estado = false;
      });
  }

}
